import React from "react";
import AppRouter from "./routes/AppRouter";
import { createTheme, ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";

const theme = createTheme({});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRouter />
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
